import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../../Store/helper/axiosInstance';
import { INTERACTIVE_SPQ_LIST } from '../QueryKeys/interactiveSPQ.key';
const cacheTime = 600000;
const staleTime = 30000;

export const useInteractiveSPQ = (type, id, onSuccess, onError) => {
  return useQuery(
    [INTERACTIVE_SPQ_LIST, type, id],
    () => axiosInstance.get(`interactiveSpq/listing?type=${type}&typeid=${id}`),
    {
      onSuccess,
      onError,
      select: (response) => response.data.data,
      // staleTime: staleTime,
      cacheTime: cacheTime,
      refetchOnWindowFocus: false
    }
  );
};
